import { validate } from 'rut.js';

import { VALIDATIONS, buildValidation } from '~utils/inputValidations';
import { CURRENT_COUNTRY_CODE } from '~constants/validation';
import { COUNTRIES, CURRENT_COUNTRY_ID } from '~constants/environment';

import { FIELDS } from './constants';

export const validationSchema = (currentUser, validateCardCode) => {
  const validation = {
    coupon: VALIDATIONS.coupon,
    [FIELDS.privacyPolicies]: VALIDATIONS.privacyPolicies,
    [FIELDS.tipField]: VALIDATIONS.tipField
  };

  if (!currentUser) {
    validation[FIELDS.name] = VALIDATIONS.nameCreation;
    validation[FIELDS.email] = VALIDATIONS.emailValidation;
    validation[FIELDS.phone] = VALIDATIONS.phoneCreation;
    validation[FIELDS.privacyPolicies] = VALIDATIONS.termsAndConditions;
  } else if (currentUser && !currentUser.phone) {
    validation[FIELDS.phone] = VALIDATIONS.phoneCreation;
    validation[FIELDS.privacyPolicies] = VALIDATIONS.termsAndConditions;
  }

  if (validateCardCode) {
    validation[FIELDS.cardCode] = VALIDATIONS.cardCode;
  }
  validation[FIELDS.identificationType] = VALIDATIONS.identificationType;
  validation[FIELDS.clientDocumentId] = VALIDATIONS.clientDocumentId;
  validation[FIELDS.nif] = VALIDATIONS.nif;

  return buildValidation(validation);
};

export const getInitialValues = currentUser => ({
  [FIELDS.name]: currentUser.name,
  [FIELDS.email]: currentUser.email,
  [FIELDS.phone]: currentUser.phone || CURRENT_COUNTRY_CODE,
  [FIELDS.privacyPolicies]:
    currentUser.acceptPrivacyPolicies ||
    (currentUser.isGuestUser && currentUser.privacyPolicies) ||
    ![COUNTRIES.es, COUNTRIES.pt].includes(CURRENT_COUNTRY_ID),
  [FIELDS.idNumber]: currentUser.idNumber
});

const getUserData = user =>
  Object.keys(user).reduce((completedUser, key) => {
    const value = user[key];

    if (value) {
      completedUser[key] = value;
    }

    return completedUser;
  }, {});

export const completeUserValues = (user, formData) => {
  let result = {};

  if (user) {
    result = getUserData(user);
    if (!user.phone) {
      result.phone = formData.phone;
    }
    if (!user.idNumber && validate(formData.idNumber)) {
      result.idNumber = formData.idNumber;
    }
  } else {
    result = getUserData(formData);
  }
  return result;
};

// we use this const when validating tokenized cards on ingenico
// https://epayments-support.ingenico.com/es/integration-solutions/integrations/3dsv2-parameters
export const ingenico3DSv2 = () => ({
  browserColorDepth: window.screen.colorDepth.toString(),
  browserJavaEnabled: navigator.javaEnabled(),
  browserLanguage: navigator.language || navigator.userLanguage,
  browserScreenWidth: window.screen.width,
  browserScreenHeight: window.screen.height,
  browserTimeZone: new Date().getTimezoneOffset(),
  browserUserAgent: navigator.userAgent
});

const countriesWithEmergency = [COUNTRIES.es, COUNTRIES.cl];

export const cardsNotAllowed = CURRENT_COUNTRY_ID === COUNTRIES.pa || CURRENT_COUNTRY_ID === COUNTRIES.cr;

// FIXME : hotfix for ingenico failure on spain 30/08/2020
// FIXME : hotfix for transbank failure on spain 31/08/2020
export const emergencyMessage = countriesWithEmergency.includes(CURRENT_COUNTRY_ID);
